import { createElement } from '../core/utils/dom.js';

export function toolCard(tool) {
  const card = createElement('a', {
    className: 'card tool-card',
    attributes: { href: `#/tools/${tool.slug}/` }
  });

  const icon = createElement('span', {
    className: 'tool-icon',
    text: tool.icon || '🔧'
  });

  const name = createElement('h3', {
    className: 'tool-name',
    text: tool.name
  });

  const desc = createElement('p', {
    className: 'tool-description',
    text: tool.description
  });

  card.appendChild(icon);
  card.appendChild(name);
  card.appendChild(desc);

  return card;
}
